// extracted by mini-css-extract-plugin
module.exports = {"loginImageWrapper":"UserLogin_loginImageWrapper__3XWFT","loginImage":"UserLogin_loginImage__2twpt"};